import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { array } from "../../shared/src/codecs/types/array";
import { form } from "../../shared/src/codecs/types/form";
import { EmptyObject } from "./EmptyObject";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { union } from "../../shared/src/codecs/types/union";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { partial } from "../../shared/src/codecs/types/partial";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { AttachmentDeliveryMode } from "./AttachmentDeliveryMode";


export const EmailAttachments = required({
    enquiries: array(string()),
    files: array(string()),
    redemption_statements: array(string()),
    quotes: array(string()),
});

export type TEmailAttachmentsCodec = typeof EmailAttachments;
export type TEmailAttachments = TTypeOfCodec<TEmailAttachmentsCodec>;

export const WeeklyUpdateMarker = required({
    case_id: string(),
    bucket_at_time: string(),
    ai_subject_at_draft: string(),
    ai_body_at_draft: string(),
});
export type TWeeklyUpdateMarkerCodec = typeof WeeklyUpdateMarker;
export type TWeeklyUpdateMarker = TTypeOfCodec<TWeeklyUpdateMarkerCodec>;

export const EmailComposition = intersection([
    partial({
        emailId: string(),
        quality_score_json: string(),
        was_quality_overridden: boolean(),
        was_dictated: boolean(),
        weekly_update_marker: WeeklyUpdateMarker,
    }),
    required({
        caseID: union([string(), nullCodec()]),
        subject: string(),
        sentFrom: string(),
        sendTo: array(string()),
        cc_addresses: array(string()),
        bcc_addresses: array(string()),
        body: string(),
        body_draft: string(),
        attachments: EmailAttachments,
        attachment_delivery_mode: AttachmentDeliveryMode,
    }),
]);
export type TEmailCompositionCodec = typeof EmailComposition;
export type TEmailComposition = TTypeOfCodec<TEmailCompositionCodec>;

export const AddEmailUserForm = form( 
    required({
        email: string(),
        first_name: string(),
        last_name: string(),
    }),
    EmptyObject,
);
export type TAddEmailUserFormCodec = typeof AddEmailUserForm;
export type TAddEmailUserForm = TTypeOfCodec<TAddEmailUserFormCodec>;
